import * as tslib_1 from "tslib";
import { OnInit, OnDestroy, ChangeDetectorRef, ElementRef } from '@angular/core';
import { Store } from '@ngrx/store';
import { Actions, ofType } from '@ngrx/effects';
import { ReplaySubject, combineLatest } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Selectors, Actions as RootActions } from 'store/root-reducer';
import * as CustomerActions from 'store/actions/customer.actions';
import { DialogService } from 'modules/shared/components/dialog/dialog.service';
import { DomainService } from 'modules/core/services/domain.service';
import { SnackbarService } from 'app/services/snackbar.service';
var CustomerAccessControlPage = /** @class */ (function () {
    function CustomerAccessControlPage(cdRef, domainService, dialog, snackbar, store, actions$) {
        this.cdRef = cdRef;
        this.domainService = domainService;
        this.dialog = dialog;
        this.snackbar = snackbar;
        this.store = store;
        this.actions$ = actions$;
        this.unsubscribe$ = new ReplaySubject(1);
        this.totalDomains = [];
        this.loading = false;
        this.breadcrumbs = [];
        // the number of domains shown when "show less" is clicked
        this.domainLimit = 20;
        this.isShowAll = false;
        this.displayedDomains = [];
        // to push to user notifications' dropdown
        this.customerDomains = [];
    }
    CustomerAccessControlPage.prototype.ngOnInit = function () {
        this.getCurrentDomain();
        this.getUpdateDomainActionStatus();
        this.initDomains();
    };
    CustomerAccessControlPage.prototype.ngOnDestroy = function () {
        this.unsubscribe$.next(null);
        this.unsubscribe$.complete();
    };
    CustomerAccessControlPage.prototype.loadBreadcrumbs = function (customerId, customerName) {
        this.breadcrumbs = [
            {
                url: '/customers',
                label: 'Customer List'
            }, {
                url: "/customers/" + customerId,
                label: customerName
            }, {
                url: "/customers/" + customerId + "/access-control",
                label: 'Access Control'
            }
        ];
    };
    CustomerAccessControlPage.prototype.getCurrentDomain = function () {
        var _this = this;
        this.store
            .select(Selectors.domain.getCurrentDomain)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(function (res) {
            _this.currentDomain = res;
        });
    };
    CustomerAccessControlPage.prototype.initDomains = function () {
        var _this = this;
        var domainsPayload = {
            offset: 0,
            limit: 999
        };
        this.loading = true;
        this.cdRef.detectChanges();
        combineLatest([
            this.domainService.getAllDomains(domainsPayload),
            this.store.select(Selectors.customer.getCustomer)
        ])
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(function (_a) {
            var domains = _a[0], customer = _a[1];
            if (domains.results && customer && customer.domains) {
                _this.customer = customer;
                _this.customerDomains = [];
                _this.loadBreadcrumbs(customer.id, customer.name);
                _this.totalDomains = domains.results.map(function (domain) {
                    return tslib_1.__assign({}, domain, { checked: false });
                });
                customer.domains.forEach(function (customerDomain) {
                    var index = _this.totalDomains.findIndex(function (domain) { return domain.id === customerDomain; });
                    if (~index) {
                        _this.customerDomains.push(_this.totalDomains[index]);
                        _this.totalDomains[index].checked = true;
                    }
                });
                if (_this.isShowAll) {
                    _this.displayedDomains = _this.totalDomains.slice();
                }
                else {
                    _this.displayedDomains = _this.totalDomains.slice(0, _this.domainLimit);
                }
                _this.loading = false;
                _this.cdRef.detectChanges();
            }
        });
    };
    CustomerAccessControlPage.prototype.updateDomain = function (domain, event) {
        var _this = this;
        var payload = {
            customer: Object.assign({}, this.customer),
            redirectToCustomerList: false
        };
        this.loading = true;
        this.cdRef.detectChanges();
        if (event.checked) {
            payload.customer.domains = this.customer.domains.concat([domain.id]);
            this.newDomain = domain;
            this.store.dispatch(new RootActions.customer.PatchCustomer(payload));
            this.userNotificationsCard.nativeElement.scrollIntoView({ behavior: 'smooth' });
        }
        else {
            payload.customer.domains = this.customer.domains.filter(function (domainId) { return domainId !== domain.id; });
            if ((domain.id === this.currentDomain.id)) {
                if (this.customer.domains.length <= 1) {
                    event.source.toggle();
                    this.snackbar.error('At least one domain needs to be selected.');
                    this.loading = false;
                }
                else {
                    this.dialog.confirm('Are you sure you want to remove this customer from your current domain?', 'Confirm Domain Update')
                        .subscribe(function (res) {
                        if (res === 'submit') {
                            payload.redirectToCustomerList = true;
                            _this.store.dispatch(new RootActions.customer.PatchCustomer(payload));
                        }
                        else {
                            _this.loading = false;
                            event.source.toggle();
                        }
                    });
                }
            }
            else {
                this.newDomain = this.currentDomain;
                this.store.dispatch(new RootActions.customer.PatchCustomer(payload));
            }
        }
    };
    /**
     * Inits observables for getting update domain action status
     * @method getUpdateDomainActionStatus
     */
    CustomerAccessControlPage.prototype.getUpdateDomainActionStatus = function () {
        var _this = this;
        this.actions$.pipe(ofType(CustomerActions.CustomerActionTypes.PATCH_CUSTOMER_SUCCESS), takeUntil(this.unsubscribe$))
            .subscribe(function () {
            _this.snackbar.success('Customer access successfully updated');
        });
        this.actions$.pipe(ofType(CustomerActions.CustomerActionTypes.PATCH_CUSTOMER_FAILURE), takeUntil(this.unsubscribe$))
            .subscribe(function (res) {
            _this.snackbar.error(res.payload);
            _this.store.dispatch(new RootActions.customer.ClearErrors());
        });
    };
    CustomerAccessControlPage.prototype.showAllDomains = function () {
        this.isShowAll = true;
        this.displayedDomains = this.totalDomains;
    };
    CustomerAccessControlPage.prototype.showLessDomains = function () {
        this.isShowAll = false;
        this.displayedDomains = this.totalDomains.slice(0, this.domainLimit);
    };
    CustomerAccessControlPage.prototype.isAllSelected = function () {
        return this.customerDomains.length === this.totalDomains.length;
    };
    CustomerAccessControlPage.prototype.isIndeterminate = function () {
        return (this.customerDomains.length > 0 && !this.isAllSelected());
    };
    CustomerAccessControlPage.prototype.selectAll = function (event) {
        var _this = this;
        var payload = {
            customer: Object.assign({}, this.customer),
            redirectToCustomerList: false
        };
        this.loading = true;
        this.cdRef.detectChanges();
        if (event.checked) {
            this.dialog.confirm('Are you sure you want to grant access of this customer to all users in all domains?', 'Confirm Domain Update', true, true)
                .subscribe(function (res) {
                if (res === 'submit') {
                    _this.displayedDomains = _this.totalDomains.slice();
                    payload.customer.domains = _this.displayedDomains.map(function (selectedDomain) { return selectedDomain.id; }).slice();
                    _this.store.dispatch(new RootActions.customer.PatchCustomer(payload));
                }
                else {
                    event.source.checked = false;
                    event.source.indeterminate = true;
                    _this.loading = false;
                    _this.cdRef.detectChanges();
                }
            });
        }
        else {
            this.dialog.confirm('Are you sure you want to deselect all domains?\n Please note that your current domain will not be deselected.', 'Confirm Domain Update', true, true)
                .subscribe(function (res) {
                if (res === 'submit') {
                    payload.customer.domains = [_this.currentDomain.id];
                    _this.store.dispatch(new RootActions.customer.PatchCustomer(payload));
                }
                else {
                    event.source.checked = true;
                    _this.loading = false;
                    _this.cdRef.detectChanges();
                }
            });
        }
    };
    CustomerAccessControlPage.prototype.updateNotifications = function (event) {
        var payload = {
            customer: Object.assign({}, this.customer),
            redirectToCustomerList: false
        };
        payload.customer.users = event.map(function (user) { return user.oauthId; });
        this.store.dispatch(new RootActions.customer.PatchCustomer(payload));
    };
    return CustomerAccessControlPage;
}());
export { CustomerAccessControlPage };
